import { create } from 'zustand'

type CollabratorState = {
  collaboratorID?: string
  setCollaboratorID: (id?: string) => void
}

export const useCollaboratorStore = create<CollabratorState>((set) => ({
  collaboratorID: undefined,
  setCollaboratorID: (id) => set({ collaboratorID: id }),
}))
